import * as firebase from "firebase/app"
import "firebase/auth"
import "firebase/firestore"
import "firebase/performance"
import "firebase/storage"

import firebaseConfig from './firebaseConfig'

firebase.initializeApp(firebaseConfig)

export const auth = firebase.auth()
export const db = firebase.firestore()
export const perf = firebase.performance()
export const storage = firebase.storage()

export async function checkToken() {

  auth.onAuthStateChanged(user => {
    if (user) {
      user.getIdTokenResult().then(token => {
        storeIdToken(token)
        return
      })
    } else {
      removeIdToken()
      return
    }
  })

}

export function storeIdToken(token:firebase.auth.IdTokenResult) {
  localStorage.setItem('idToken', token.token)
  localStorage.setItem('idTokenCreated', Date.parse(token.authTime).toString())
  localStorage.setItem('idTokenExpires', Date.parse(token.expirationTime).toString())
  localStorage.setItem('idTokenScope', token.claims.permissions || "")
}

export function removeIdToken() {
  localStorage.removeItem('idToken')
  localStorage.removeItem('idTokenCreated')
  localStorage.removeItem('idTokenExpires')
  localStorage.removeItem('idTokenScope')
}

export default {
  // @ts-ignore
  install(Vue) {

    Vue.prototype.$firebase = firebase

    Vue.prototype.$auth = auth
    Vue.prototype.$db = db
    Vue.prototype.$perf = perf
    Vue.prototype.$storage = storage

    auth.onAuthStateChanged(user => {
      if (user) {
        checkToken()
      } else {
        removeIdToken()
      }
    })
  }
}
